module.exports = __webpack_public_path__ + "static/media/linkedin-dark.92d53950.png";